import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sh-logs-2-matrics-description',
  templateUrl: './logs-2-matrics-description.component.html',
  styleUrls: ['./logs-2-matrics-description.component.scss']
})
export class Logs2MatricsDescriptionComponent {
}
